import useSoopiEmbedStore from '@/stores/main/soopiEmbed';
import globalDomains from '@/utils/global-domains';
import {useEffect} from 'react';
import styles from './styles.module.css';
const Embed = ({broadType, broadUrl}) => {
  const {player, setPlayer} = useSoopiEmbedStore();
  useEffect(() => {
    // 스크립트가 이미 존재하는지 확인
    const existingScript = document.getElementById('embed-script');
    if (!existingScript) {
      const script = document.createElement('script');
      script.id = 'embed-script'; // 스크립트에 ID 추가
      script.src = `${globalDomains.STATIC_AFREECATV}/asset/app/embed/embed.min.js`;
      document.head.appendChild(script);
      window.onAFIframeAPIReady = () => {
        const embedPlayer = new AF.Player('soopiPreviewPlayer', {
          mutePlay: false,
          autoPlay: true,
          showChat: broadType !== 'Catch',
          isAdShow: true,
          showQualityBox: false,
          fromApi: 1,
          apiKey: '0c36a94',
          playerFunc: broadType === 'Catch' ? 'catch' : undefined,
        });
        if (embedPlayer) {
          const broadUrls = broadUrl.split('/');
          console.log(broadUrl.split('/'), broadUrls[broadUrls.length - 2]);

          if (broadType === 'VOD' || broadType === 'Catch') {
            embedPlayer.loadVideo({
              videoId: broadUrls[broadUrls.length - 1],
            });
          } else {
            embedPlayer.loadVideo({
              channelId: broadUrls[broadUrls.length - 2],
            });
          }
          setPlayer(embedPlayer);
        }
      };
    } else {
      const broadUrls = broadUrl.split('/');
      if (player) {
        if (broadType === 'VOD' || broadType === 'Catch') {
          player.loadVideo({
            videoId: broadUrls[broadUrls.length - 1],
          });
        } else {
          player.loadVideo({
            channelId: broadUrls[broadUrls.length - 2],
          });
        }
      } else {
        const embedPlayer = new AF.Player('soopiPreviewPlayer', {
          height: '450',
          width: '800',
          mutePlay: false,
          autoPlay: true,
          showChat: broadType !== 'Catch',
          isAdShow: true,
          showQualityBox: false,
          fromApi: 1,
          apiKey: '0c36a94',
          playerFunc: broadType === 'Catch' ? 'catch' : undefined,
        });

        if (broadType === 'VOD') {
          embedPlayer.loadVideo({
            videoId: broadUrls[broadUrls.length - 1],
          });
        } else {
          embedPlayer.loadVideo({
            channelId: broadUrls[broadUrls.length - 2],
          });
        }
        setPlayer(embedPlayer);
      }
    }
  }, [broadUrl, broadType]);
  return (
    <div className={styles['soopiPreviewContainer']}>
      <div id='soopiPreviewPlayer' />
    </div>
  );
};

export default Embed;
